import mediaControlSvg from "@/utils/svg-icon/mediaControl";
import { MDBBtn } from "mdb-react-ui-kit";
import styles from "styles/search/Chip.module.scss";

export const Chip = ({
    value,
    onClick,
}: {
    value: string;
    onClick: () => void;
}) => {
    return (
        <MDBBtn className={styles.filterRecapButton}>
            <span className="ps-2">{value}</span>
            <div className="ps-2 pt-2" onClick={onClick}>
                <mediaControlSvg.CloseCircleFilled />
            </div>
        </MDBBtn>
    );
};
